import { Controller } from "@hotwired/stimulus";
import Hls from "hls.js";
import "./component.scss";

export default class extends Controller {
  static targets = [
    "video",
    "playButton",
    "playIcon",
    "pauseIcon",
    "timeCurrent",
    "timeTotal",
    "progressBarContainer",
    "progressBarIndicator",
    "progressBarHandle",
    "volumeSlider",
    "volumeUpIcon",
    "volumeOffIcon",
  ];

  connect() {
    // this.hls = new Hls();
    // this.hls.loadSource(this.videoTarget.src);
    // this.hls.attachMedia(this.videoTarget);

    this.updateProgress();
    this.updateTime();

    this.videoTarget.addEventListener(
      "timeupdate",
      this.updateProgress.bind(this)
    );

    this.videoTarget.addEventListener("timeupdate", this.updateTime.bind(this));
  }

  togglePlay() {
    if (this.videoTarget.paused) {
      this.videoTarget.play();
      this.playIconTarget.classList.add("c-video_player-hidden");
      this.pauseIconTarget.classList.remove("c-video_player-hidden");
    } else {
      this.videoTarget.pause();
      this.playIconTarget.classList.remove("c-video_player-hidden");
      this.pauseIconTarget.classList.add("c-video_player-hidden");
    }
  }

  updateProgress() {
    const video = this.videoTarget;
    if (!video.duration) return;

    const percent = (video.currentTime / video.duration) * 100;
    this.progressBarHandleTarget.style.left = `${percent}%`;
    this.progressBarIndicatorTarget.style.width = `${percent}%`;
  }

  updateTime() {
    const video = this.videoTarget;
    const formatTime = (time) =>
      new Date(time * 1000).toISOString().substring(11, 19);

    this.timeCurrentTarget.textContent = formatTime(video.currentTime || 0);
    this.timeTotalTarget.textContent = formatTime(video.duration || 0);
  }

  scrub(event) {
    const rect = this.progressBarContainerTarget.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const newTime = (clickX / rect.width) * (this.videoTarget.duration || 0);
    this.videoTarget.currentTime = newTime;
  }

  updateVolume() {
    this.videoTarget.volume = parseFloat(this.volumeSliderTarget.value);

    if (parseFloat(this.volumeSliderTarget.value) === 0) {
      this.volumeUpIconTarget.classList.add("c-video_player-hidden");
      this.volumeOffIconTarget.classList.remove("c-video_player-hidden");
    } else {
      this.volumeUpIconTarget.classList.remove("c-video_player-hidden");
      this.volumeOffIconTarget.classList.add("c-video_player-hidden");
    }
  }

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      this.element.requestFullscreen().catch((err) => console.error(err));
    } else {
      document.exitFullscreen();
    }
  }
}
